<script>
import { isHexColor } from '../shared';
import { ICON_ASSIGNMENT_COLORS, ICON_BASE_COLORS, ICON_SIZES } from './config';

export default {
  props: {
    /**
     * @values Hexadecimal Color (#hex), white, black, links, primary, primary-light, secondary, secondary-light,
     * warning, warning-light, warning-dark, danger, danger-light, calm, calm-light, gray-100, gray-200, gray-300,
     * gray-500, gray-600, gray-900, coral, ruby, chili, raffia, sienna, carrot, egg, olive, bamboo, meadow, aquamarine,
     * aqua, sky, sea, ocean, navy, cornflower, wisteria, mauvelous, mulberry
     * */
    color: {
      required: false,
      type: String,
      default: null,
      validator: (value) => !value || ICON_BASE_COLORS.includes(value) || ICON_ASSIGNMENT_COLORS.includes(value)
        || isHexColor(value),
    },
    /**
     * @values 8, 12, 16, 18, 20, 24, 32, 48, 64
     * */
    size: {
      required: false,
      type: Number,
      default: 16,
      validator: (value) => !value || ICON_SIZES.includes(value),
    },
  },

  computed: {
    iconClass() {
      const classes = [
        'svg-icon',
        `svg-icon-${this.$options.iconName}`,
      ];

      const { color, size } = this;

      if (size) {
        classes.push(`svg-icon-size-${size}`);
      }

      if (color && !isHexColor(color)) {
        classes.push(`svg-icon-color-${color}`);
      }

      return classes;
    },
    iconStyle() {
      const { color } = this;

      if (isHexColor(color)) {
        return { fill: `${color}` };
      }

      return '';
    },
  },

  created() {
    if (!this.$options.iconName) {
      throw new Error('Cannot create instance of BaseIcon. Provide iconName in options.');
    }
  },
};
</script>
